
import React from 'react';
import { cn } from '@/lib/utils';
import ReactMarkdown from 'react-markdown';

interface Message {
  role: 'user' | 'assistant';
  content: string;
}

interface MessageItemProps {
  message: Message;
  isLastMessage: boolean;
  messageRef: React.RefObject<HTMLDivElement>;
}

const MessageItem: React.FC<MessageItemProps> = ({ message, isLastMessage, messageRef }) => {
  return (
    <div 
      ref={isLastMessage ? messageRef : undefined}
      className={cn(
        "p-4 rounded-lg",
        message.role === 'user' 
          ? "bg-gray-100/80 ml-10 text-black" 
          : "bg-gray-200/80 mr-10 border border-gray-300/50 text-black"
      )}
    >
      {message.role === 'user' ? (
        <div className="font-medium">
          {message.content}
        </div>
      ) : (
        <ReactMarkdown 
          className="prose prose-sm max-w-none"
          components={{
            h3: ({ node, ...props }) => <h3 className="text-lg font-semibold my-2" {...props} />,
            ul: ({ node, ...props }) => <ul className="list-disc pl-5 my-2" {...props} />,
            li: ({ node, ...props }) => <li className="my-1" {...props} />,
            p: ({ node, ...props }) => <p className="my-2" {...props} />,
            a: ({ node, ...props }) => <a className="text-blue-600 hover:underline" {...props} />,
            strong: ({ node, ...props }) => <strong className="font-semibold" {...props} />,
            em: ({ node, ...props }) => <em className="italic" {...props} />,
            code: ({ node, ...props }) => <code className="bg-gray-100 rounded px-1 py-0.5 text-sm" {...props} />,
            blockquote: ({ node, ...props }) => <blockquote className="border-l-4 border-gray-300 pl-4 italic my-2" {...props} />
          }}
        >
          {message.content}
        </ReactMarkdown>
      )}
    </div>
  );
};

export default MessageItem;
